export default "__VITE_ASSET__BKvAzp3u__"